import { render, staticRenderFns } from "./product-options.vue?vue&type=template&id=03c7db55"
import script from "./product-options.vue?vue&type=script&lang=ts"
export * from "./product-options.vue?vue&type=script&lang=ts"
import style0 from "./product-options.vue?vue&type=style&index=0&id=03c7db55&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03c7db55')) {
      api.createRecord('03c7db55', component.options)
    } else {
      api.reload('03c7db55', component.options)
    }
    module.hot.accept("./product-options.vue?vue&type=template&id=03c7db55", function () {
      api.rerender('03c7db55', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/product-options.vue"
export default component.exports